const homeAndProsResponsiveConfig = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 1
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 1
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 1
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1
	}
};

const list = [
	{
		thumbnailUrl: '/images/Brand-Landing-Pages/inspire-home-decor/Tips-1-820x575.jpg',
		tipText: 'Use crystal lighting in an entry hall or living room to create glamour and movement.'
	},
	{
		thumbnailUrl: '/images/Brand-Landing-Pages/inspire-home-decor/Tips-2-820x575.jpg',
		tipText: 'Clean, streamlined designs make a modern statement that I love.'
	},
	{
		thumbnailUrl: '/images/Brand-Landing-Pages/inspire-home-decor/Tips-3-820x575.jpg',
		tipText: 'I feature gold finishes for their warm, understated elegance.'
	},
	{
		thumbnailUrl: '/images/Brand-Landing-Pages/inspire-home-decor/Tips-4-820x575.jpg',
		tipText: 'Think of lighting as jewelry for your home and a way to add a little dazzle.'
	}
];

export { homeAndProsResponsiveConfig, list };
